import { AnchorButton } from "@rootreeweb/ui";

import image from "@/assets/holiday-cards/holiday-card-gift-tags.png";
import { DayDefinition } from "../DayDefinition.js";

/**
 * Class Gift_Tags
 *
 * Represents the Gift Tags card.
 */
export class Gift_Tags extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-orange2022";
	public image = image;

	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "gift-tags";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Printable Gift Tags";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`You finished your shopping list; all your gifts are bundled in cute boxes and bags...
					Only to realize that you forgot cute matching name tags.
					Rest assured, stay cool, you’ve done so much
					Here’s a print & cut kit to add your final touch`}
				</p>
				<img
					alt="Gift Tag Thumbnail"
					className={"hl:mb-4"}
					src="https://rootree.ca/wp-content/uploads/2022/11/Gift-Tag-Thumbnail.png"
				/>
				<AnchorButton
					className={"hl:mx-auto hl:no-underline"}
					colour={"white"}
					href="https://rootree.ca/wp-content/uploads/2022/11/AllGiftTags_Combined.pdf"
					target="_blank"
				>
					Download Gift Tags
				</AnchorButton>
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Étiquettes-cadeaux à imprimer";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Vous avez terminé votre liste de courses et tous vos cadeaux sont enfin emballés.
					Mais sur les paquets aucun nom n'est encore indiqué !
					Rassurez-vous, restez cool, vous en avez déjà fait tellement...
					Voici un kit d'impression et de découpe pour ajouter les ultimes éléments.`}
				</p>
				<img
					alt="Gift Tag Thumbnail"
					className={"hl:mb-4"}
					src="https://rootree.ca/wp-content/uploads/2022/11/Gift-Tag-Thumbnail.png"
				/>
				<AnchorButton
					className={"hl:mx-auto hl:no-underline"}
					colour={"white"}
					href="https://rootree.ca/wp-content/uploads/2022/11/AllGiftTags_Combined.pdf"
					target="_blank"
				>
					Téléchargez l’étiquette-cadeau
				</AnchorButton>
			</>
		);
	}
}
